import { FieldArray, FormikProps } from "formik";
import { GoPlus } from "react-icons/go";
import { MdDelete } from "react-icons/md";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { UpcomingInstallmentValues } from "src/models/UpcomingInstallment.model";
import { handleValidNumber } from "src/utils/validations/numberInput";

type Props = {
  formikProps: FormikProps<UpcomingInstallmentValues>;
  onClose: () => void;
};

const UpcomingInstallmentForm = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  const isInvalidInstallment =
    Number(values.totalDueAmount) !==
    values?.installments?.reduce((sum, installment) => {
      return sum + Number(installment?.amount);
    }, 0);
 
  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium"> Update Installment </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="">
        <div className="text-slate-600 font-semibold text-md">
          <span> Total Due Amount : </span>
          <span className="text-xl text-red-400 font-bold italic">
            &#8377; {values?.totalDueAmount}
          </span>
        </div>
        {isInvalidInstallment && (
          <div className="text-red-400 font-semibold text-md italic">
            Total Installment amount should be equal to Total Due Amount
          </div>
        )}

        <div className="mt-1">
          <FieldArray
            name="installments"
            render={({ push, remove }) => (
              <>
                {values?.installments?.map((installment: any, index: any) => {
                  return (
                    <div key={index}>
                      <div className="grid grid-cols-12 gap-6 items-center mt-3">
                        {/* Date Picker */}
                        <div className="col-span-5">
                          <ATMDatePicker
                            format="DD-MM-YYYY"
                            name={`installments[${index}].dueDate`}
                            value={installment?.dueDate || null}
                            onChange={(newValue) =>
                              setFieldValue(
                                `installments[${index}].dueDate`,
                                newValue
                              )
                            }
                            label="Due Date"
                          />
                        </div>
                        <div className="col-span-5">
                          <ATMTextField
                            name={`installments[${index}].amount`}
                            value={installment?.amount}
                            onChange={(e) =>
                              handleValidNumber(e) &&
                              setFieldValue(
                                `installments[${index}].amount`,
                                e.target.value
                              )
                            }
                            label="Amount"
                            placeholder="Enter Amount"
                            onBlur={handleBlur}
                          />
                        </div>
                        {values?.installments?.length !== 1 && (
                          <div className="col-span-1 mt-3">
                            <MdDelete
                              color="#F70913"
                              size={30}
                              className="pl-1 cursor-pointer"
                              onClick={() => remove(index)}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}

                <div className="flex justify-end mt-2">
                  <button
                    type="button"
                    className="text-link font-semibold text-base text-[16px] max-[1024px]:text-sm flex items-center"
                    disabled={
                      values?.installments?.reduce((sum, installment) => {
                        return sum + Number(installment?.amount);
                      }, 0) < Number(values.totalDueAmount)
                        ? false
                        : true
                    }
                    onClick={() =>
                      push({
                        dueDate: null,
                        amount:
                          Number(values.totalDueAmount) -
                          values?.installments?.reduce((sum, installment) => {
                            return sum + Number(installment?.amount);
                          }, 0),
                      })
                    }
                  >
                    <GoPlus size={18} color="#0064C4" className="mr-2" />
                    Add Installment
                  </button>
                </div>
              </>
            )}
          />

          {/* Remark */}
          <div className="">
            <ATMTextArea
              name="remark"
              value={values.remark}
              onChange={(newValue) => setFieldValue("remark", newValue)}
              label="Remark"
              placeholder="Enter Remark"
              onBlur={handleBlur}
            />
          </div>
        </div>
      </div>
      <div>
        <ATMLoadingButton
          isLoading={isSubmitting}
          type="submit"
          disabled={isInvalidInstallment}
        >
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default UpcomingInstallmentForm;
